import { router } from '@inertiajs/react';
import { Mail } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import type { SharedProps } from '@/types';

export function ResendEmailButton({ emailId }: { emailId: string }) {
  const [isPending, setIsPending] = useState(false);
  const [message, setMessage] = useState<{
    type: 'success' | 'error';
    text: string;
  } | null>(null);

  const showFor5Seconds = (next: { type: 'success' | 'error'; text: string }) => {
    setMessage(next);
    setTimeout(() => setMessage(null), 5000);
  };

  const handleResend = () => {
    setIsPending(true);
    router.post(
      `/admin/emails/${emailId}/resend`,
      {},
      {
        preserveScroll: true,
        onSuccess: (page) => {
          const { flash } = page.props as unknown as SharedProps;
          showFor5Seconds(
            flash.alert
              ? { type: 'error', text: flash.alert }
              : {
                  type: 'success',
                  text: flash.notice ?? 'Email resent successfully!',
                },
          );
        },
        onError: () =>
          showFor5Seconds({ type: 'error', text: 'Failed to resend email' }),
        onFinish: () => setIsPending(false),
      },
    );
  };

  return (
    <div className="space-y-4">
      <Button onClick={handleResend} disabled={isPending} className="w-full">
        <Mail className="mr-2 h-4 w-4" />
        {isPending ? 'Resending...' : 'Resend Email'}
      </Button>

      {message && (
        <div
          className={`rounded-md border p-3 text-sm ${
            message.type === 'success'
              ? 'border-green-200 bg-green-50 text-green-800'
              : 'border-red-200 bg-red-50 text-red-800'
          }`}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}
